module.exports = __webpack_public_path__ + "static/media/kaggle.d4e4fc31.gif";